import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { IFacturacion } from 'src/app/interfaces/facturacion';
import { FacturacionService } from 'src/app/services/datos/facturacion.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

// entorno
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-facturacion-seguros',
  templateUrl: './seguros.component.html',
  styleUrls: ['./seguros.component.scss']
})
export class SegurosComponent implements OnInit {

  @Input() datosCabecera: IFacturacion = {}
  @Output() totalSeguros = new EventEmitter<any>();

  public loading: boolean = false;
  public sinDatos: boolean = false;

  datosFacturacion: any[] = [];
  totales: any = {};

  constructor(
    private facturaSrv: FacturacionService,
    private notificacionesSrv: NotificacionesService
  ) { }

  ngOnInit(): void { }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['datosCabecera'] && this.datosCabecera && Object.keys(this.datosCabecera).length > 0) {
      this.enviarDatos();
    }
  }

  enviarDatos(): void {
    console.log('__seguros/enviar() OK: ', this.datosCabecera);

    this.loading = true;
    this.facturaSrv.facSeguros(this.datosCabecera).subscribe(resp => {
      this.loading = false;
      this.sinDatos = false;

      console.log('__seguros/facturacion()', resp);

      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }

      this.datosFacturacion = resp.data.seguros;
      this.totales = resp.totales;

      // Emitir total al padre
      this.totalSeguros.emit(this.totales.cliente);

      if (!this.totales || this.totales.length === 0) {
        this.sinDatos = true;
      }

      console.log('__seguros/totales', this.totales);
    });
  }


  abrirPdfClick() {
    console.log('__abrirPdfClick()', this.totales.pdfName);
    const urlPdf: string = environment.pdfDir + '/facturacion/' + this.totales.pdfName;
    window.open(urlPdf, '_blank');
  }


  /// AUX ///

  // Función para verificar si un objeto está vacío
  isObjectEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }
}